export default __webpack_public_path__ + "static/media/logo-login.7f248fd0.svg";